 
import { registerView } from '../viewRegistry';
import { generateAsciiArt, ensureFigletFont } from '../../utils/asciiArt';

const HERO_LINES = ['DOPE', 'CHAIN', 'WARS'];

// Cache for generated ASCII art per line
const _heroAsciiCache = {}; let _heroAsciiReady = false;

async function ensureHeroAscii() {
  if (_heroAsciiReady) return;
  try {
    await ensureFigletFont('ANSI Shadow', '/fonts/figlet/ANSI_Shadow.flf');
    for (const line of HERO_LINES) {
      _heroAsciiCache[line] = await generateAsciiArt(line, { font: 'ANSI Shadow', width: 60 });
    }
    _heroAsciiReady = true;
  } catch (err) {
    console.error('Failed to generate hero ASCII art:', err);
  }
}

async function renderHeroUniversal(ctx, t, w, h, params = {}) {
  // Clear the canvas each frame to avoid cumulative glow that looks "bold"
  ctx.fillStyle = '#000000';
  ctx.fillRect(0, 0, w, h);

  if (!_heroAsciiReady) {
    ensureHeroAscii();
    ctx.font = 'bold 24px monospace';
    ctx.fillStyle = '#39FF14';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('Loading…', w / 2, h / 2);
    return;
  }

  const padding = Math.max(24, Math.floor(Math.min(w, h) * 0.06));
  const usableW = w - padding * 2;
  const usableH = h - padding * 2;

  // Build single ASCII art block like splash/icon
  const heroArt = _heroAsciiCache[HERO_LINES[0]] + '\n' + _heroAsciiCache[HERO_LINES[1]] + '\n' + _heroAsciiCache[HERO_LINES[2]];
  const asciiLines = heroArt.split('\n');

  ctx.font = '100px monospace';
  const widestLine = asciiLines.reduce((a, b) => (a.length > b.length ? a : b));
  const widthAt100 = ctx.measureText(widestLine).width;

  const candidateByW = (usableW / widthAt100) * 100;
  const candidateByH = usableH / asciiLines.length;
  const lineHeight = Math.max(1, Math.round(Math.min(candidateByW, candidateByH) * 0.90));
  ctx.font = `${lineHeight}px monospace`;

  const totalArtH = lineHeight * asciiLines.length;
  let yCursor = (h - totalArtH) / 2;

  ctx.fillStyle = '#39FF14';
  ctx.shadowColor = '#39FF14';
  ctx.shadowBlur = 10;

  // Ensure the following drawText uses left alignment since we calculate startX manually
  ctx.textAlign = 'left';
  ctx.textBaseline = 'top';

  asciiLines.forEach(asciiLine => {
    const lineW = ctx.measureText(asciiLine).width;
    const startX = (w - lineW) / 2;
    ctx.fillText(asciiLine, startX, yCursor);
    yCursor += lineHeight;
  });

  ctx.shadowBlur = 0;

  // Add tagline for hero images (if space allows)
  if (h >= 400 && w >= 800) {
    const taglineY = yCursor + padding / 2;
    if (taglineY + 30 < h - padding) {
      ctx.font = `${Math.floor(14 * (lineHeight / 100))}px monospace`;
      ctx.fillStyle = '#39FF14';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';
      ctx.globalAlpha = 0.8;
      ctx.fillText('Retro CRT cyberpunk strategy on-chain', w / 2, taglineY);
      ctx.globalAlpha = 1.0;
    }
  }

  // Subtle frame border for hero presentation
  ctx.strokeStyle = '#39FF14';
  ctx.lineWidth = 3;
  ctx.globalAlpha = 0.3;
  ctx.strokeRect(
    padding / 2,
    padding / 2,
    w - padding,
    h - padding
  );
  ctx.globalAlpha = 1.0;

  // Signal completion for build scripts
  if (typeof window !== 'undefined') {
    window.DCW_HERO_READY = true;
    console.log('[HERO_UNIVERSAL] DCW_HERO_READY flag set');
  }

  // (Auto-redirect removed – view now respects ?profile parameter provided)
}

registerView('hero_universal', renderHeroUniversal); 